import {
	Button,
	Grid,
	Image,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Spinner,
	Tooltip,
	useDisclosure,
} from '@chakra-ui/react';
import axios from 'axios';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { IconAssets } from 'src/config';
import { Color } from 'src/theme/color';

export const LoadSteamData = () => {
	const { setFieldValue } = useFormikContext();

	const { isOpen, onOpen, onClose } = useDisclosure();

	const [steamUrl, setSteamUrl] = useState<string>('');
	const [isUrlOk, setIsUrlOk] = useState<boolean>(true);
	const [preparedUrl, setPreparedUrl] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);

	useEffect(() => {
		const match = matchSteamString(steamUrl);
		const isOk = match != null && match[2] != '' && match[2] != null;
		setIsUrlOk(isOk);

		if (isOk && match != null && match[2] != null) {
			setPreparedUrl(createSteamAPIUrl(match[2]));
		}
	}, [steamUrl]);

	const matchSteamString = (url: string) => {
		const match = url.match('(https:\\/\\/store\\.steampowered\\.com\\/app\\/)(\\d*)');
		return match;
	};

	const createSteamAPIUrl = (appId: string) => {
		return `https://6cpne6wmai.execute-api.eu-west-1.amazonaws.com/?id=${appId}`;
	};

	const handleChange = (e: any) => {
		setSteamUrl(e.target.value);
	};

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);

		axios
			.get(preparedUrl)
			.then(res => {
				console.log(res.data.name);
				const data = res.data.data;
				console.log(data);

				setFieldValue('name', data.name);
				setFieldValue('media.cover', data.header_image);

				setIsLoading(false);
			})
			.catch(e => {
				console.log(e);
				setIsLoading(false);
				setIsUrlOk(false);
			});
	};

	return (
		<>
			<Tooltip label="Load data from steam">
				<Image
					cursor="pointer"
					src={IconAssets.steam}
					boxSize="44px"
					onClick={onOpen}
				/>
			</Tooltip>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent
					margin="auto"
					border="1px solid"
					borderColor={Color.HASHUP}
					bg={Color.FORM_BACKGROUND}
					maxW="620px"
					padding="40px"
					display="flex"
					justifyContent="center"
					gap="30px"
					alignItems="center"
					textAlign="center"
				>
					<ModalHeader
						lineHeight="100%"
						m="0"
						p="0"
						maxW="350px"
					>
						Load Data from Steam
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody
						m="0"
						p="0"
						color={Color.GRAY_2}
						display="flex"
						justifyContent="center"
					>
						If your game is already on Steam copy its profile address, so we can automate some parts of publishing process!
					</ModalBody>

					<Grid
						w="300px"
						margin="0 auto"
						templateColumns="1fr 50px"
					>
						<Input onChange={handleChange} />
						<Button
							onClick={handleSubmit}
							disabled={!isUrlOk}
						>
							{isLoading ? (
								<Spinner
									w="8px"
									h="8px"
								/>
							) : (
								'Load'
							)}
						</Button>
					</Grid>
				</ModalContent>
			</Modal>
		</>
	);
};
